import React from "react";
import { IMaskInputProps } from "react-imask/esm/mixin";
import { IMaskInput } from "react-imask/esm/index";

export const MaskedTextField = React.forwardRef<
    HTMLInputElement,
    IMaskInputProps<HTMLInputElement>
>((props, ref) => <IMaskInput {...props} inputRef={ref} />);

MaskedTextField.displayName = "MaskedTextField";

export default MaskedTextField;

